/**
 * @author Karthik <karthik@314ecorp.com>
 * @description Space Access Denied Error
 */

interface ISpaceAccessDeniedError {
	spaceId: string | null;
}

class SpaceAccessDeniedError extends Error {
	constructor(params: ISpaceAccessDeniedError) {
		super(`SpaceAccessDeniedError: Access denied for space ${params.spaceId}`);
		this.name = 'SpaceAccessDeniedError';
	}
}

export default SpaceAccessDeniedError;
